/* Responsibility: Renders the save search form which allows saving LMS searches. */
import { toast } from '@finn-no/common-browserbundle';
import url from '../../lib/urlQuery.js';
import dom from '../../lib/dom.js';
import preconditions from '../../lib/preconditions.js';

const T = FINN.travel;

const checkPreconditions = preconditions('setupSaveSearch', {
    root: 'element',
    template: 'string',
    subMarket: 'string',
    browserWindow: 'object',
    eventHub: 'eventHub',
    saveSearch: 'function',
    resultViewCriteria: 'object',
});

export default function setupSaveSearch(params) {
    checkPreconditions(params);

    const showSaveSearchMessage = function (err, data) {
        if (err || !data) {
            toast({ message: T.lang.save_search_failure(), level: 'error' });
        } else {
            toast({ message: T.lang.save_search_success() });
        }
    };

    const submitSaveSearch = function () {
        params.saveSearch(
            {
                searchName: params.root.querySelector('[data-save-search-name]').value,
                url: url(params.browserWindow.location.href).queryParameters().toString(),
                csrfToken: params.root.querySelector('[data-save-search-csrfToken]').value,
            },
            showSaveSearchMessage
        );

        params.eventHub.publish('hide-modal');
    };

    const getSaveSearchName = function (query) {
        let name = '';
        if (query.fra && query.fra.length) {
            name += ` fra ${query.fra.join('+')}`;
        }
        if (query.til && query.til.length) {
            const loc = query.til;
            name += ` til ${loc[loc.length - 1].split(';').pop()}`;
        }
        if (query.med && query.med.length) {
            name += ` med ${query.med.join('+')}`;
        }
        if (query.avreise && query.avreise.length) {
            name += ` med avreise ${query.avreise}`;
        }
        return params.subMarket + name;
    };

    const showModal = function (button) {
        dom.on(button, 'click', (e) => {
            e.stop();

            params.root.innerHTML = params.template;
            button.disabled = false;

            const saveSearchName = params.root.querySelector('[data-save-search-name]');
            if (saveSearchName) {
                saveSearchName.value = getSaveSearchName(params.resultViewCriteria);
            }

            params.eventHub.publish('show-modal', {
                eventName: 'save-search',
                title: 'Lagre søk',
                buttonText: 'Lagre',
                hideConfirm: dom.byQuerySelector('[data-testid="saveSearchLoginButton"]', params.root).length > 0,
            });
        });
    };

    if (Array.isArray(params.showModal)) {
        params.showModal.forEach((button) => showModal(button));
    } else {
        showModal(params.showModal);
    }

    params.eventHub.subscribe('save-search', submitSaveSearch);
}
